import { createActionNameList } from 'utils'

export default createActionNameList('SESSION_STATUS')(
  'UNKNOWN',
  'UNAUTHENTICATED',
  'AUTHENTICATED'
)